import axiosInstance from "@/lib/axiosInstance";
import { formBuilderAssignmentsEndpoints } from "./formBuilderAssignments.endpoints";
import type { CreateAssignmentPayload } from "./formBuilderAssignments.types";

export const createAssignment = async (payload: CreateAssignmentPayload) => {
  const response = await axiosInstance.post(formBuilderAssignmentsEndpoints.assignments, payload);
  return response.data;
};

export const deleteAssignment = async (assignmentId: string, tenantId: string) => {
  const response = await axiosInstance.delete(
    `${formBuilderAssignmentsEndpoints.assignments}/${assignmentId}`,
    { params: { tenantId } },
  );
  return response.data;
};

export const replaceAssignment = async ({
  create,
  deleteId,
}: {
  create: CreateAssignmentPayload;
  deleteId?: string;
}) => {
  // Delete first: the backend's duplicate-scope check keys on
  // (workOrderType, formType, tradeId, subtradeId) — not templateId — so
  // creating before deleting always 409s against the row being replaced.
  if (deleteId) {
    await deleteAssignment(deleteId, create.tenantId);
  }
  return createAssignment(create);
};

export const createAssignments = async (payloads: CreateAssignmentPayload[]) => {
  for (const payload of payloads) {
    await createAssignment(payload);
  }
};
